import React from "react";

const Bash_Sed = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Sed</h2>
      <p>Stream editor for filtering and transforming text.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>sed [options] 'script' file</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>sed 's/old/new/g' file.txt
sed -n '1,5p' file.txt</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use -i to edit files in-place (careful!).</p>
    </div>
  );
};

export default Bash_Sed;
